import type { AppData } from '../../types/app_data';
import { StepCategory } from '../../types/app_data';
import type { Step } from '../types/step';

export const PremiumStep: Step = {
  // Ask user's current premium and term.
  id: 'askPremium',
  pathname: '/premium',
  canShow: (appData: AppData) => {
    if (!appData.selectedService?.insurance) {
      return false;
    }

    if (appData.signupParams?.needNNOInsurance === true) {
      return false;
    }

    return !appData.isOnboardingLite && !!appData.signupParams?.isAutoInsured;
  },
  hasData: () => true,
  // Premium page can be skipped.
  hasOwnData: () => true,
  category: () => StepCategory.Other,
};
